<template>
<section class="aqi-panel">
  <section class="aqi-base-info">
    <!-- <span class="aqi-area-name">{{data.areaName}}</span> -->
    <span class="aqi-area-name">{{ currentAddress }}</span>
    <div class="aqi-data-time-info">
      <span class="aqi-data-time-label">更新时间:</span>
      <span class="aqi-data-time">{{data.dataTime.format()}}</span>
    </div>
  </section>

  <section class="aqi-level-value-layout">
    <section class="aqi-level-value-inner">
      <div class="aqi-level-percentage">
        <svg viewBox="0 0 100 100">
          <path
            d="M 50 50 m 0 47 a 47 47 0 1 1 0 -94 a 47 47 0 1 1 0 94"
            stroke="#e5e9f2"
            stroke-width="4.8"
            stroke-linecap="round"
            fill="none"
            style="stroke-dasharray:221.482px,295.31px;stroke-dashoffset:-36.9137px;"
          ></path>
          <path
            d="M 50 50 m 0 47 a 47 47 0 1 1 0 -94 a 47 47 0 1 1 0 94"
            :stroke="data.aqiColor"
            fill="none"
            stroke-linecap="round"
            stroke-width="4.8"
            style="stroke-dashoffset:-36.9137px;transition:stroke-dasharray 0.6s ease 0s,stroke 0.6s ease 0s;"
            :style="{
                  'stroke-dasharray': `${data.aqiPercentage * 2.21482}px, 295.31px`
                }"
          ></path>
        </svg>
      </div>
      <div class="aqi-info-wrapper">
        <img :src="aqiLevelImgPath[data.level - 1]" class="aqi-level-img" draggable="false" />
        <div class="aqi-info-value">{{data.aqi}} {{data.levelName}}</div>
      </div>
    </section>
  </section>

  <p class="aqi-primary-pollutant">
    <span>首要污染物:</span>
    <span>{{data.primary ? data.primary.replaceAll('_24H', '') : '-'}}</span>
    <span style="margin-left:8px;">浓度:</span>
    <span>{{Number.isFinite(data.primaryValue) ? data.primaryValue : '--'}}{{data.primaryUnit}}</span>
  </p>

  <ul class="aqi-info-item-wrapper pollutant-info">
    <li
      v-for="(value, index) in data.values"
      :key="index"
      class="pollutant-item"
    >
      <div class="pollutant-value">
        <span>{{value.name}}</span>
        <span>{{value.value}}</span>
      </div>
      <div class="pollutant-percentage">
        <el-progress
          :percentage="value.percentage"
          :color="value.color"
          :stroke-width="4"
          :show-text="false"
        />
      </div>
      <div class="pollutant-unit">{{value.unit}}</div>
    </li>
  </ul>

  <ul class="aqi-info-item-wrapper weather-info">
    <li>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 1439 1024">
        <path d="M331.212938 803.191375a193.207547 193.207547 0 0 0 193.207547-187.687332V41.401617a41.401617 41.401617 0 0 0-82.803234 0v565.822103a110.404313 110.404313 0 0 1-220.808626 0 42.50566 42.50566 0 0 0-41.401617-41.401618A42.50566 42.50566 0 0 0 138.005391 607.22372a193.207547 193.207547 0 0 0 193.207547 195.967655zM1131.644205 803.191375a193.207547 193.207547 0 0 0 193.207547-193.207548 41.401617 41.401617 0 0 0-82.803234 0 110.404313 110.404313 0 0 1-220.808626 0V41.401617a41.401617 41.401617 0 0 0-82.803234 0V609.983827a193.207547 193.207547 0 0 0 193.207547 193.207548zM731.428571 803.191375a42.50566 42.50566 0 0 0 41.401618-41.401618v-579.622641a41.401617 41.401617 0 0 0-82.803235 0v579.622641a42.50566 42.50566 0 0 0 41.401617 41.401618zM1393.854447 941.196765h-1352.45283a41.401617 41.401617 0 0 0 0 82.803235h1352.45283a42.50566 42.50566 0 0 0 41.401618-41.401617 40.573585 40.573585 0 0 0-41.401618-41.401618z"></path>
      </svg>
      <span class="weather-value">{{Number.isFinite(data.pressure) ? data.pressure : '--'}}hpa</span>
    </li>
    <li>
      <svg height="16" width="16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 471 471">
        <g transform="translate(0 -540.36)">
          <g>
            <g>
              <path d="M302.317,699.16h35.3c5.5,0,10-4.5,10-10s-4.5-10-10-10h-35.3c-5.5,0-10,4.5-10,10S296.817,699.16,302.317,699.16z"></path>
              <path d="M203.517,875.76v-220.5c0-5.5-4.5-10-10-10s-10,4.5-10,10v220.5c-20.6,4.6-36,23-36,44.9c0,25.4,20.6,46,46,46 c25.4,0,46-20.6,46-46C239.517,898.76,224.117,880.36,203.517,875.76z M193.517,946.66c-14.3,0-26-11.7-26-26s11.7-26,26-26 c14.3,0,26,11.7,26,26C219.517,935.06,207.817,946.66,193.517,946.66z"></path>
              <path d="M251.717,846.26v-249.9c0-30.9-25.9-56-57.9-56c-32.5,0-58.9,25.1-58.9,56v249.9c-31.1,24.3-43.6,64.2-31.2,101 c6,18.7,17.8,34.7,34.1,46.3c16.3,11.6,35.6,17.8,55.9,17.8c19.8,0,38.9-6.2,55.3-17.8c16.2-11.6,28.2-27.6,34.7-46.2 c0-0.1,0.1-0.2,0.1-0.3C295.417,910.16,282.517,870.26,251.717,846.26z M264.717,941.06c-10.4,29.7-39.6,50.4-71,50.4 c-32.8,0-61.3-20.2-71-50.3c-0.1-0.1-0.1-0.1-0.1-0.2c-10.2-30,1-62.7,27.9-81.4c2.7-1.9,4.3-4.9,4.3-8.2v-255 c0-19.9,17.5-36,38.9-36c20.6,0,38,16.5,37.9,36v255c0,3.3,1.6,6.3,4.3,8.2C262.517,878.16,274.117,910.86,264.717,941.06z"></path>
              <polygon points="193.717,1011.36 193.717,1011.36 193.717,1011.36 "></polygon>
              <path d="M362.017,817.86h-59.7c-5.5,0-10,4.5-10,10s4.5,10,10,10h59.7c5.5,0,10-4.4,10-10 C372.017,822.36,367.517,817.86,362.017,817.86z"></path>
              <path d="M362.017,633.16h-59.7c-5.5,0-10,4.5-10,10s4.5,10,10,10h59.7c5.5,0,10-4.5,10-10S367.517,633.16,362.017,633.16z"></path>
              <path d="M302.317,607.16h35.3c5.5,0,10-4.4,10-10c0-5.5-4.5-10-10-10h-35.3c-5.5,0-10,4.5-10,10S296.817,607.16,302.317,607.16z"></path>
              <path d="M302.317,560.36h59.7c5.5,0,10-4.5,10-10s-4.5-10-10-10h-59.7c-5.5,0-10,4.5-10,10S296.817,560.36,302.317,560.36z"></path>
              <path d="M302.317,791.96h35.3c5.5,0,10-4.5,10-10s-4.5-10-10-10h-35.3c-5.5,0-10,4.5-10,10S296.817,791.96,302.317,791.96z"></path>
              <path d="M362.017,725.96h-59.7c-5.5,0-10,4.5-10,10s4.5,10,10,10h59.7c5.5,0,10-4.5,10-10S367.517,725.96,362.017,725.96z"></path>
            </g>
          </g>
        </g>
      </svg>
      <span class="weather-value">{{Number.isFinite(data.temperature) ? data.temperature : '--'}}℃</span>
    </li>
    <li>
      <svg height="16" viewBox="0 0 12.558 16.481">
        <path stroke="none" d="M262.279,173.143a.785.785,0,0,1,0-1.569,1.028,1.028,0,0,0,1.012-1.044.785.785,0,1,1,1.569,0A2.6,2.6,0,0,1,262.279,173.143Zm-.016-11.2c.957,1.169,2.2,2.778,3.233,4.112l.063.086c1.569,2.048,2.134,5.218.11,7.313a4.653,4.653,0,0,1-6.748,0c-1.828-1.9-1.781-4.841.118-7.321l.659-.871c.847-1.114,1.789-2.354,2.566-3.311Zm0-1.938a.91.91,0,0,0-.7.33c-1.051,1.248-2.6,3.311-3.766,4.849-2.276,2.982-2.48,6.787,0,9.361a6.222,6.222,0,0,0,9.016,0c2.48-2.574,2.2-6.521,0-9.361-1.224-1.569-2.809-3.625-3.845-4.849a.918.918,0,0,0-.691-.337Z" transform="translate(-256.015 -160)"></path>
      </svg>
      <span class="weather-value">{{Number.isFinite(data.humidity) ? data.humidity : '--'}}%</span>
    </li>
    <li>
      <svg
        height="16"
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        :style="`transform:rotate(${Number.isFinite(data.windDir) ? (data.windDir + 180) : 0}deg)`"
      >
        <g transform="translate(-50.000000, -60.000000)">
          <polygon
            fill="none"
            transform="translate(58.000000, 68.000000) scale(1, -1) rotate(90.000000) translate(-58.000000, -68.000000) "
            points="50 73 55.3076923 68 50 63 66 68"
          ></polygon>
        </g>
      </svg>
      <span class="weather-value">{{Number.isFinite(data.windLevel) ? data.windLevel : '--'}}级</span>
    </li>
  </ul>
  <p style="margin: 0; font-size: 10px;">数据来源：{{ dataSources }}</p>
</section>
</template>

<script>
import AreaAQI from './AreaAQI'

export default {
  name: 'AqiPanel',
  props: {
    data: {
      required: true,
      type: AreaAQI
    },
    aqiLevelImgPath: {
      required: true,
      type: Array
    }
  },
  computed: {
    dataSources: () => process.env.DATA_SOURCES,
    currentAddress: () => process.env.CURRENT_ADDRESS
  }
}
</script>

<style lang="scss">
.aqi-panel {
  --color: var(--aqi-panel-color, #ffffff);

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: var(--aqi-panel-width, 302px);
  height: var(--aqi-panel-height, 582px);
  line-height: var(--aqi-panel-line-height, 1.15);
  padding: var(--aqi-panel-padding, 18px);
  border: var(--aqi-panel-border, 0) {
    radius: var(--aqi-panel-border-radius, 15px);
  };
  background: var(--aqi-panel-bg, rgba(255, 255, 255, .4));
  color: var(--color);
  fill: var(--color);
  stroke: var(--color);

  .aqi-base-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;

    .aqi-data-time-info {
      font-size: .75em;
    }
  }

  .aqi-level-value-layout {
    position: relative;
    width: 67.66917293233082%;
    padding-bottom: 67.66917293233082%;

    .aqi-level-value-inner {
      position: absolute;
      width: 100%;
      height: 100%;
      padding: 8px;
    }

    .aqi-level-percentage {
      width: 100%;
      height: 100%;
    }

    .aqi-info-wrapper {
      position: absolute;
      display: flex;
      flex-direction: column;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
    }

    .aqi-level-img {
      width: 44.44444444444444%;
    }

    .aqi-info-value {
      padding-top: .25em;
      text-align: center;
    }
  }

  .aqi-primary-pollutant {
    font-size: .875em;
    text-align: center;
  }

  .aqi-info-item-wrapper {
    width: 100%;
    margin: 0 0 1em 0;
    padding: 0 0 1em 0;
    border-radius: var(--aqi-panel-item-border-radius, 6px);
    list-style: none;
    background: rgba(51, 67, 100, .3);
  }

  .pollutant-info {
    display: grid;
    grid-template: {
      columns: 1fr 1fr 1fr;
    };

    .pollutant-item {
      margin-top: 1em;
    }

    .pollutant-value {
      font-size: .875em;
      display: flex;
      justify-content: space-between;
      padding: 3px 8px;
    }

    .pollutant-percentage {
      padding: 0 8px;
    }

    .pollutant-unit {
      font-size: .75em;
      line-height: 1.5333333333333332;
      text-align: center;
      opacity: .8;
    }
  }

  .el-progress-bar__outer {
    background-color: #999;
  }

  .weather-info {
    font-size: .875em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1em 8px;

    > * {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .weather-value {
      margin-top: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/01Data-Overview/AqiPanel.vue